/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=7320ed16&scoped=true&"
import script from "./drawer.vue?vue&type=script&lang=ts&"
export * from "./drawer.vue?vue&type=script&lang=ts&"
import style0 from "./drawer.vue?vue&type=style&index=0&id=7320ed16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320ed16",
  null
  
)

export default component.exports